import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import env from "../env";
import { globalObject } from "../system";
import util from "../util";
import config from "./config";
import { openMiddlePage } from "./utils/helpers";
var callbacks = [];
var loadScript = false;
var isInQnReadingApp = globalObject.navigator ? globalObject.navigator.userAgent.indexOf('qnreading') >= 0 : false;
function readyCallback() {
  window.TencentNews = window.TencentNews || window.TencentReading;
  var _iterator = _createForOfIteratorHelper(callbacks),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var func = _step.value;
      func();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  callbacks = [];
}
function newsApiReady(func) {
  if (window.TencentNews || window.TencentReading) {
    window.TencentNews = window.TencentNews || window.TencentReading;
    func();
  } else {
    if (env.isAndroid && !loadScript) {
      util.loadScript('news_script', env.isAndroid && isInQnReadingApp ? '//mat1.gtimg.com/www/reading/android/js/jsapi/jsapi.js' : '//mat1.gtimg.com/www/js/newsapp/jsapi/news.js?_tsid=1', function () {
        readyCallback();
      });
      loadScript = true;
    } else if (env.isIos || env.isIpad) {
      if (!window._TencentNewsReady_) {
        window._TencentNewsReady_ = readyCallback;
      }
    }
    callbacks.push(func);
  }
}
export var canGetInstallState = true;
export function ready() {
  return new Promise(function (resolve) {
    newsApiReady(resolve);
  });
}
export function getInstallState() {
  var conf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : config;
  return new Promise(function (resolve) {
    newsApiReady(function () {
      if (env.isIos) {
        TencentNews.checkCanOpenNativeUrl(conf.packageUrl, function (url, result) {
          resolve(result);
        });
      } else if (env.isAndroid) {
        var packageName = conf.packageName;
        window.checkCanOpenNativeUrlCallBack = function (result) {
          resolve(result);
        };
        if (isInQnReadingApp) {
          TencentNews.checkCanOpenNativeUrl(packageName, 'checkCanOpenNativeUrlCallBack', null);
        } else {
          TencentNews.checkCanOpenNativeUrl(packageName, 'checkCanOpenNativeUrlCallBack');
        }
      }
    });
  });
}
export function launch(_x) {
  return _launch.apply(this, arguments);
}
function _launch() {
  _launch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(schemeUrl) {
    var conf,
      _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            conf = _args.length > 1 && _args[1] !== undefined ? _args[1] : config;
            if (env.isIos) {
              TencentNews.openNativeUrl(schemeUrl, function () {}, null);
            } else if (env.isAndroid) {
              TencentNews.openApp(schemeUrl, conf.packageName);
            }
            return _context.abrupt("return", true);
          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _launch.apply(this, arguments);
}
export function download() {
  return _download.apply(this, arguments);
}
function _download() {
  _download = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var conf,
      isOpenAppPage,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            conf = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : config;
            isOpenAppPage = openMiddlePage(); // 只有 openapp 中间页才拉起下载
            if (isOpenAppPage) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return");
          case 4:
            if (env.isIos) {
              TencentNews.openNativeUrl(conf.download, function () {}, null);
            } else if (env.isAndroid) {
              TencentNews.downloadApp(conf.download, conf.packageName, '应用下载');
              TencentNews.showTextTips('开始下载APP！');
            }
          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _download.apply(this, arguments);
}
export default {
  canGetInstallState: canGetInstallState,
  ready: ready,
  getInstallState: getInstallState,
  launch: launch,
  download: download
};